import script from "./resmanage.vue?vue&type=script&setup=true&lang=js"
export * from "./resmanage.vue?vue&type=script&setup=true&lang=js"

import "./resmanage.vue?vue&type=style&index=0&id=e5145a66&lang=scss"

const __exports__ = script;

export default __exports__